// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__KT001","ActionBox":"styles_ActionBox__QVWU-"};